export const emptyApplicant: IApplicant = {
  auId: 0,
  basisForAdmission: '',
  examCode: '',
  courses: [],
  email: '',
  name: '',
  nationality: '',
  phoneNumber: '',
  quotient: '',
};

const initialState: IAppState = {
  congratulate: false,
  congratulateMoveIn: false,
};

export default initialState;
